import styled from '@emotion/styled';
import { css } from '@emotion/core/';

import NavMenuList from './NavMenuList';
import NavMenuItem from './NavMenuItem';

const baseStyles = () => css`
  width: 100%;
  padding: 0 16px;
`;

const NavMenu = styled('nav')(baseStyles);

NavMenu.List = NavMenuList;
NavMenu.Item = NavMenuItem;

export default NavMenu;
